import { render } from "./ResultsView.vue?vue&type=template&id=eb8a89cc&scoped=true"
import script from "./ResultsView.vue?vue&type=script&lang=js"
export * from "./ResultsView.vue?vue&type=script&lang=js"

import "./ResultsView.vue?vue&type=style&index=0&id=eb8a89cc&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb8a89cc"]])

export default __exports__